import { render, staticRenderFns } from "./CardCollapsable.vue?vue&type=template&id=653b32ae&scoped=true&"
import script from "./CardCollapsable.vue?vue&type=script&lang=js&"
export * from "./CardCollapsable.vue?vue&type=script&lang=js&"
import style0 from "./CardCollapsable.vue?vue&type=style&index=0&id=653b32ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b32ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('653b32ae')) {
      api.createRecord('653b32ae', component.options)
    } else {
      api.reload('653b32ae', component.options)
    }
    module.hot.accept("./CardCollapsable.vue?vue&type=template&id=653b32ae&scoped=true&", function () {
      api.rerender('653b32ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CardCollapsable.vue"
export default component.exports